import Immutable from 'immutable';
import {
  CLEAR_POSITIONS,
  FLAG_GETTING_POSITIONS,
  GET_POSITIONS,
} from '../../../actions/types/hcm/Position';

const INITIAL_STATE = Immutable.Map({
  content: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_POSITIONS:
      return state.setIn(['content', 'loading'], payload);

    case GET_POSITIONS:
      return state.setIn(
        ['content', 'content'],
        Immutable.fromJS(payload || []),
      );

    case CLEAR_POSITIONS:
      return state.setIn(
        ['content', 'content'],
        INITIAL_STATE.getIn(['content', 'content']),
      );

    default:
      return state;
  }
};
